import { NavLink } from 'react-router-dom';
import { X } from 'react-feather';
import Logo from '../../../assets/images/ist-logo.png';

const SidebarHeader = (props) => {
  const { setMenuVisibility } = props;

  return (
    <div className="navbar-header">
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item me-auto">
          <NavLink to="/" className="navbar-brand">
            <span className="brand-logo">
              <img src={Logo} alt="logo" />
            </span>
          </NavLink>
        </li>
        <li className="nav-item nav-toggle">
          <div className="nav-link modern-nav-toggle cursor-pointer">
            <X
              onClick={() => setMenuVisibility(false)}
              className="toggle-icon icon-x d-block d-xl-none"
              size={20}
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default SidebarHeader;
